import { ThinkerView } from "./../../shared/views/thinker";
import { SearchFilterView } from "./search-filter";
import { SearchDownloadView } from "./search-download";
import { SearchAlertView } from "./search-alert";
import { NoResultsView } from "./no-results";
import { NoResultsModel } from "./../models/no-results";
import { AdvancedSearchView } from "./advanced-search/advanced-search";
import Marionette from "../../shared/marionette-mustache";
import { autoinject } from "aurelia-dependency-injection";
import { SearchModel } from "../../search/models/search";
import { Results } from "../../search/views/results";
import { ExactResultView } from "../../search/views/exact-result";
import { backboneViewProperties } from "../../decorators/backbone-properties";
import { AppEvents } from "../../app-events";
import { IRequestOptions } from "../../search/interfaces/request-options";
import { Container } from "aurelia-dependency-injection";
import { MobileHelper } from "../../shared/helpers/mobile-helper";
import { UserSettingsModel } from "../../settings/models/user-settings";
import { UserDetailsView } from "../../shared/views/user-details";

import { StatuteOutlineView } from "./statute-outline";
import { AuthService } from "../../authentication/auth-service";
import { AppUser } from "../../authentication/app-user";

const template = require<string>("../../search/views/search.html");

const pagerTemplate = require<string>("../../search/views/pager-popover.html");

const dom = {
    DOCUMENT_LINKS: ".document-link",
    EXPLANATION_ICON: ".lucene-explanation-icon",
    PAGE_BUTTONS: ".js-results-pager",
    JURISDICTION_DROP_DOWN: "#search-jurisdiction",
    JURISDICTION_FILTER: ".js-jurisdiction-filter input[type='checkbox']",
    JUSTISDICTION_SETTING_SHOW: ".js-show-jurisdiction-setttings",
    MATERIAL_FILTER_REGION: "#material-filter-region",
    MATERIAL_FILTER_TOGGLE: "#material-filter",
    MATERIAL_FILTER: ".js-material",
    STANDARD_RESULTS_REGION: "#standard-results-region",
    CATEGORY_FILTER_LABEL: ".js-category-filter-selected-label",
    CATEGORY_FILTER: "a.js-category-filter",
    CATEGORY_FILTER_REGION: "#category",
    DOCUMENT_FILTERS: "checkbox-filter",
    SEARCH_TEMPLATE: "#search-template",
    RESULTS: "#results",
    RESULTS_REGION: "#results-list-region",
    EXACT_REGION: "#exact-result-region",
    ORDER_LINKS: ".js-order",
    SELECTED_ORDER_LABEL: ".js-order-label",
    ORDER_TOGGLE: "#sorter",
    CURRENT_PAGE: ".js-current-page",
    TOTAL_PAGES: ".js-total-pages",
    SEARCH_BOX: "#search-box",
    SEARCH_PILL: ".search-pill",
    SEARCH_MORE: ".expanded-search-drawer",
    ADVANCED_SEARCH_REGION: "#advanced-search-region",
    ADVANCED_SEARCH_FORM_REGION: "#advanced-search-form-region",
    SEARCH_THINKER: "#search-thinker",
    SEARCH_MASK: "#suggestion-mask",
    RESULTS_PAGER: ".js-results-pager",
    PAGE_LEFT: ".js-results-pager[data-page='left']",
    PAGE_RIGHT: ".js-results-pager[data-page='right']",
    MIDDLE_PAGER: ".js-results-pager-middle",
    NEXT_PAGE_BUTTON: "#next-page-button",
    ADVANCED_TAB: ".advanced-tab",
    RESULTS_LIST_REGION: "#results-list-region",
    RESULT_MESSAGE_CONTENT: ".message-content",
    RESULT_MESSAGE_CLOSER: ".message-closer",
    TOUR_BUTTON: "#tour-button",
    ADVANCED_SEARCH_RUN: "#advanced-search-run",
    ADVANCED_SEARCH_CLEAR: "#advanced-search-clear",
    ADVANCED_SEARCH_ERROR_MESSAGE: "#advanced-search-error-message",
    ADVANCED_SEARCH_CLOSER: ".advanced-search-closer",
    ADVANCED_SEARCH_LOADING: "#advanced-search-loading",
    EXPAND_SEARCH: "#expand-to-all-jurisdictions",
    SPELLING_CORRECTION: "#spelling-correction",
    RESULTS_NAVBAR: "#results .navbar",
    ERROR_BAR: "#error-region",
    ERROR_BAR_MESSAGE: "#error-message",
    NO_RESULTS_EXPLANATION_PANEL: ".no-results-explanation-panel",
    PREVIOUS_SEARCH_LINK: ".prev-search-link",
    DOWNLOAD_REGION: "#download-region",
    DOWNLOAD_BUTTON: "#download-menu",
    FILTER_BUTTON: "#filter-menu",
    ALERT_BUTTON: "#alert-menu",
    RESULTS_CONTROLS_PANEL_REGION: ".results-controls-panel-region",
    NO_RESULTS_REGION: ".no-results-panel-region",
    DOCUMENT_CITATION_LINK: ".document-citation-link"
};

@autoinject
@backboneViewProperties({
    template: template
})
export class SearchView extends Marionette.LayoutView<SearchModel> {
    private advancedSearchRegion: Marionette.Region;
    private advancedSearchFormRegion: Marionette.Region;
    private resultsRegion: Marionette.Region;
    private exactRegion: Marionette.Region;
    private noResultsPanelRegion: Marionette.Region;
    private advancedSearchView: AdvancedSearchView;
    private resultsControlsPanelRegion: Marionette.Region;
    private downloadView: SearchDownloadView;
    private filterView: SearchFilterView;
    private userSettings: UserSettingsModel;
    private alertView: SearchAlertView;
    private statuteOutlineView: StatuteOutlineView;
    private user: AppUser;

    constructor(
        private appEvents: Backbone.Events,
        public model: SearchModel,
        private authService: AuthService,
        private userDetails: UserDetailsView) {
        super();
        this.user = authService.AppUser;
        this.$el = $(this.el);
        this.userSettings = Container.instance.get(UserSettingsModel);
        this.setupEvents();
        this.setupModelChangeListeners();
    }

    public events(): Backbone.EventsHash {
        const events: Backbone.EventsHash = {};
        events["click " + dom.DOCUMENT_LINKS] = (e) => this.documentLinkClick(e);
        events["click " + dom.EXPLANATION_ICON] = (e) => this.explanationLinkClick(e);
        events["click " + dom.ORDER_LINKS] = (e) => this.orderLinkClick(e);
        events["click " + dom.PAGE_BUTTONS] = (e) => this.pageButtonClick(e);
        events["click " + dom.JUSTISDICTION_SETTING_SHOW] = (e) => this.showJurisdictionSettings(e);
        events["click " + dom.ADVANCED_SEARCH_CLEAR] = (e) => this.clearClick(e);
        events["click #sorter"] = () => this.sorterClick();
        events["click " + dom.ADVANCED_SEARCH_RUN] = (e) => this.advancedSearchRunClick(e);
        events["click " + dom.ADVANCED_SEARCH_CLOSER] = (e) => this.closeAdvancedSearchButtonClick(e);
        events["click " + dom.EXPAND_SEARCH] = () => this.expandSearchLinkClick();
        events["click " + dom.SPELLING_CORRECTION] = (e) => this.spellingCorrectionClick(e);
        events["click #expand-products-link"] = () => this.expandProductsLinkClick();
        events["click .search-clear"] = () => this.searchClear();
        events["scroll " + dom.STANDARD_RESULTS_REGION] = (e) => this.resultsScroll(e);
        events["click " + dom.PREVIOUS_SEARCH_LINK] = (e) => this.previousSearchLinkClick(e);
        events["click " + dom.DOWNLOAD_BUTTON] = (e) => this.showResultsControlsView(e, this.downloadView);
        events["click " + dom.FILTER_BUTTON] = (e) => this.showResultsControlsView(e, this.filterView);
        events["click " + dom.ALERT_BUTTON] = (e) => this.showResultsControlsView(e, this.alertView);
        events["click .dropdown"] = (e) => this.showResultsControlsView(e, null);  // to handle old style dropdowns
        events["click " + dom.DOCUMENT_CITATION_LINK] = (e) => this.documentLinkClick(e);
        return events;
    }

    public regions(): any {
        const regions: any = {
            advancedSearchRegion: dom.ADVANCED_SEARCH_REGION,
            resultsRegion: dom.RESULTS_REGION,
            exactRegion: dom.EXACT_REGION,
            resultsControlsPanelRegion: dom.RESULTS_CONTROLS_PANEL_REGION,
            noResultsPanelRegion: dom.NO_RESULTS_REGION
        };
        return regions;
    }

    public onShow() {
        this.setupPagerPopover();
        this.setupResultsView();
        this.setupResultsScroll();
        this.setupDownloadView();
        this.setupFilterMenuView();
        this.setupAlertView();
    }

    public showResultsControlsView(e: JQueryEventObject, view: Marionette.View<any>) {

        this.$("#results-controls").find(".dropdown-panel").removeClass("selected");

        if (this.resultsControlsPanelRegion.currentView === view || !view) {
            this.hideResultsControlPanel();
        } else {
            $(e.currentTarget).addClass("selected");
            this.appEvents.trigger(AppEvents.AppInsightsResultsFilterDropDownActivated, {ResultsFilterActivated: true});
            this.resultsControlsPanelRegion.show(view, {preventDestroy: true});
            this.setResultsRegionMaxHeightIfFlexboxNotSupported(view);
            this.model.DownloadModel.checkboxesEnabled = view === this.downloadView;
        }
    }

    public setResultsRegionMaxHeightIfFlexboxNotSupported(view: Marionette.View<any>) {

        if (!flexboxSupported()) {

            _.defer(() => {
                const resultsHeight = $("#results").outerHeight();
                const viewHeight = view ? $(view.el).outerHeight() : 0;
                const navbarHeight = $("#results-controls").outerHeight();

                const newMaxHeight = resultsHeight  - viewHeight  - navbarHeight  - 10;
                this.$("#standard-results-region").css("max-height", newMaxHeight); // There's no way to achieve the behaviour we want in pure CSS while still supporting IE9/10
            });

        }

    }

    public hideResultsControlPanel() {
        this.model.DownloadModel.checkboxesEnabled = false;
        this.resultsControlsPanelRegion.empty({preventDestroy: true});
        this.$("#results-controls").find(".dropdown-panel").removeClass("selected");
        this.setResultsRegionMaxHeightIfFlexboxNotSupported(null);
    }

    public setupDownloadView() {
        this.downloadView = new SearchDownloadView({model: this.model.DownloadModel});
    }

    public setupFilterMenuView() {
        this.filterView = new SearchFilterView({model: this.model});
    }

    public setupAlertView() {
        this.alertView = Container.instance.get(SearchAlertView);
    }

    public hideSearchControls() {
        this.hideAllControls();
    }

    public setupAdvancedSearchView(formID?: string) {
        return new Promise((resolve, reject) => {
            if (this.advancedSearchView && this.model.AdvancedSearch.AdvancedSearchEverOpened) {
                this.model.AdvancedSearch.selectForm(formID);
                resolve();
            } else {
                if (formID === null) {
                    formID = "all";
                }
                this.model.AdvancedSearch.load(formID).then(() => {
                    this.advancedSearchView = new AdvancedSearchView({model: this.model.AdvancedSearch});
                    this.advancedSearchRegion.show(this.advancedSearchView);
                    resolve();
                });
            }
        });
    }

    public reloadAdvancedSearchForm(): void {
        // On refresh event, this method is triggered. If Loaded set to true, then forms will render on refresh.
        this.model.AdvancedSearch.Loaded = true;
    }

    private setupResultsScroll() {
        $(dom.STANDARD_RESULTS_REGION).scroll(() => {
           this.$(".result-court").popover("hide");
        });
        $(window).resize(() => {
            this.$(".result-court").popover("hide");
        });
    }

    private setupModelChangeListeners() {
        this.listenTo(this.model, "UpdateNavBar", this.refreshNavBar);
        this.listenTo(this.model, "change:MaterialTypeCounts", this.refreshNavBar);
        this.listenTo(this.model, "change:ExactMatchResult", this.setupExactMatchView);
        this.listenTo(this.model, "change:Loading", this.loadingChanged);
        this.listenTo(this.model, "change:TotalResults", this.totalResultsChanged);

        this.listenTo(this.model, "change:AdvancedVisible", this.advancedVisibleChanged);
        this.listenTo(this.model, "change:ErrorMessage", this.errorMessageChanged);
        this.listenTo(this.user, "refresh", this.reloadAdvancedSearchForm);
        this.listenTo(this.model.DownloadModel, "reset", this.hideResultsControlPanel);
        this.listenTo(this.model.DownloadModel, "change:loading", this.downloadLoadingChanged);

        this.listenTo(this.model, "ShowOrHideResultsPane", this.showOrHideResultsPane);

        $(document).on("click", () => {
            this.appEvents.trigger(AppEvents.HideSuggestions);
        });

        this.appEvents.on(AppEvents.ClearCategoryFilter, () => {
            this.model.setCategoryFilters([], true);
        });

        this.appEvents.on(AppEvents.PageRefresh, () => {
            this.setupResultsView();
        });

        this.appEvents.on(AppEvents.WindowResized, () => { this.updateNavbarIcons(); });
    }

    private downloadLoadingChanged() {
        if (!this.model.DownloadModel.loading && this.resultsControlsPanelRegion.currentView === this.downloadView) { // if the user opens another panel before download finished we can leave that open
            this.hideResultsControlPanel();
        }
    }

    private totalResultsChanged() {
        this.$(".total-result-count").text(this.model.TotalResults);
    }

    private errorMessageChanged(model, prop): void {
        if (!this.model.ErrorMessage) {
            $(dom.ERROR_BAR).removeClass("slide-in").addClass("slide-out");
            $(dom.ERROR_BAR_MESSAGE).text("");
            return;
        }

        $(dom.ERROR_BAR).show();
        $(dom.ERROR_BAR).removeClass("slide-out").addClass("slide-in");
        $(dom.ERROR_BAR_MESSAGE).text(this.model.ErrorMessage);
        this.model.AllResults.reset();
        this.model.ExactMatchResult = null;
        this.model.TotalResults = 0;

    }

    private async showOrHideResultsPane() {
        $(dom.STANDARD_RESULTS_REGION).find(dom.NO_RESULTS_EXPLANATION_PANEL).remove(); // get rid of current one if there is one
        if (this.model.TotalResults > 0) {
            this.setupResultsView(); // There was a rare/sporadic bug where results wouldn't draw, hopefully this will fix
            return;
        }
        if (!this.model.ErrorMessage) {
            await this.setupNoResultsView();
        }
    }

    private async setupNoResultsView() {
        const allJurisdictionsSelected = await this.model.AreWeSearchingAllJurisdictions();
        const model = new NoResultsModel();
        model.RecentSearches = this.model.Welcome.RecentSearches;
        model.ResultsOutsideJurisdictionSettings = this.model.ResultsOutsideJurisdictionSettings;
        model.Query = this.model.SearchTree.toQueryString();
        model.MarkedUpQuery = this.model.SearchTree.toMarkedUpQueryString();
        model.TitleCorrection = this.model.SpellingCorrection;
        model.JurisdictionsMessage = `<strong>${this.model.ResultsOutsideJurisdictionSettings} ${(this.model.ResultsOutsideJurisdictionSettings > 1) ? "results</strong> were" : "result</strong> was"}`;
        model.JurisdictionList = this.buildJurisdictionsList(!this.model.areWeFilteringWithJurisdictionOverride() || !allJurisdictionsSelected);
        model.ProductList = this.buildProductsList();
        model.LuceneOutputText = this.model.RavenQueryString;
        this.showNoResultsPanel(model);
    }

    private buildJurisdictionsList(filtering: boolean) {
        const jurisdictionsList = [];
        const model: UserSettingsModel = this.userSettings;
        let coreSelectedCount = 0;
        if (!filtering) {
            jurisdictionsList.push(`All jurisdictions`);
        } else {
            model.CoreJurisdictions.each((core) => {
                if (core.Selected) {
                    jurisdictionsList.push(core.Name);
                    coreSelectedCount++;
                } else {
                    const childrenSelected = core.Children.filter((x) => x.Selected);
                    if (childrenSelected.length !== 0) {
                        jurisdictionsList.push(`${childrenSelected.length} jurisdiction(s) selected from ${core.Name}`);
                        coreSelectedCount++;
                    }
                }
            });

            if (model.IncludeAllOtherJurisdictions) { // If 'Other Jurisdictions' setting is selected, this will now display something depending on if any Cores are selected
                if (coreSelectedCount > 0) {
                    jurisdictionsList.push(`plus Other Jurisdictions (Non-Core)`);
                } else {
                    jurisdictionsList.push(`Other Jurisdictions (Non-Core)`);
                }
            }
        }
        return jurisdictionsList;
    }

    private buildProductsList() {
        const productsList = [];

        if (!this.model.areWeFilteringByIndicators()) {
            productsList.push("Everything");
        } else {
            this.model.AdvancedSearch.AllProductFilters.forEach((f) => {
                if (f.Included) {
                    productsList.push(f.DisplayName);
                }
            });
        }

        return productsList;
    }

    private showNoResultsPanel(model: NoResultsModel) {
        const view = new NoResultsView({model});
        this.noResultsPanelRegion.show(view);
    }

    private previousSearchLinkClick(e: JQueryMouseEventObject) {
        const query = $(e.currentTarget).attr("data-query");
        const model = this.model.Welcome.RecentSearches.where({ Query: query })[0];
        this.appEvents.trigger(AppEvents.SearchRequest, model.Options);
    }

    private expandProductsLinkClick() {
        this.model.AdvancedSearch.clearAllFilters();
    }

    private setupEvents() {
        this.appEvents.on(AppEvents.CloseAdvanced, () => {
            this.model.AdvancedVisible = false;
        });
        this.appEvents.on(AppEvents.JurisdictionsSaved, () => {
            // We only want to do something if we've previously done a search
            if (this.model.CurrentSearchTree) {
                this.model.setPage(1, false);
                this.model.SearchTree = this.model.CurrentSearchTree;
                this.model.emitSearchRequestJurisdictionUpdate();
            }
        });

        this.appEvents.on(AppEvents.RefreshResultsPagerPopup, (options) => {
            this.$(dom.MIDDLE_PAGER).popover((typeof (options) === "undefined") ? "destroy" : "hide");
        });

        this.appEvents.on(AppEvents.SearchRequest, (options: IRequestOptions) => {
            if (!options.materialTypes) {
                this.model.set("MaterialTypeCounts", "");
                this.$(".js-material-thinker").show();
                this.$(".js-material-count").text("");
            }

            if (options.includedCategoryFilters && options.includedCategoryFilters.length > 0) {
                this.$(".js-category-options").addClass("thinking");
            }
            this.model.setFilterTooltip(options);
        });
        this.appEvents.on(AppEvents.Announcement, (announcementText: string) => {
            this.setAnnouncement(announcementText);
        });
    }

    private showJurisdictionSettings(e: JQueryEventObject): void {
        e.stopPropagation();
        this.appEvents.trigger(AppEvents.AppInsightsResultsFilter, {ShowJurisdictionsButtonClicked: true});
        this.appEvents.trigger(AppEvents.SettingsVisibilityToggled);
    }

    private setupPagerPopover(): void {
        (this.$(dom.MIDDLE_PAGER) as any).popover({
            container: "#application-container",
            viewport: "#application-container",
            placement: "bottom",
            html: true,
            trigger: "manual"
        }).click(() => {
            if (!this.$(dom.MIDDLE_PAGER).hasClass("disabled")) {
                this.$(dom.MIDDLE_PAGER).popover("show");
                $("#pagerPageNum").focus();
            }
            return false;
        });

        $(document).on("submit", "#pager-popover-form", (e) => {
            e.stopPropagation();
            const pageNumSelected = $("#pagerPageNum").val();
            this.model.setPage(pageNumSelected, false);
            this.model.emitSearchRequest();
            this.$(dom.MIDDLE_PAGER).popover("hide");
            this.model.MiddlePagerEnter = true;
            return false; // don"t refresh the page, please
        });
    }

    private setupResultsView(): void {
        const collection = this.model.AllResults;
        const standardResults = new Results({ collection });
        this.resultsRegion.show(standardResults);
        this.model.set("ControlsEnabled", true);
    }

    private setupExactMatchView(): void {
        const model = this.model.ExactMatchResult;
        if (!model) {
            this.exactRegion.reset();
        }
        else {
            const docType = model.DocTypeString.toLowerCase();
            if (docType === "statute" || docType === "statute_section") {
                if (model.Outline === null) {
                    this.exactRegion.reset();
                }
                else {
                    this.statuteOutlineView = new StatuteOutlineView({model: model});
                    this.exactRegion.show(this.statuteOutlineView);
                }
            }
            else {
                const exactResult = new ExactResultView({ model: model });
                this.exactRegion.show(exactResult);
            }
        }
    }

    private advancedSearchFormFetchErrorHandler() {
        this.$(".advanced-search-controls").hide();
        $("#advanced-search-loading").text("Advanced search is currently unavailable. Please try again later.");
    }
    private updatePagerPopoverContent() {
        // lacking some of the event goodness in the newest bootstraps, we"ll have to go with this
        // better suggestions welcome
        const $popover = this.$(dom.MIDDLE_PAGER);
        // make our popover"s content dynamically
        const currentPage = this.model.getPage();
        const total = this.model.TotalResults;
        if (!total || total === 0 || !currentPage) {
            return;
        }
        const lastPage = Math.ceil(total / 10);
        if (lastPage === 1) {
            $popover.popover("disable");
        } else {
            $popover.popover("enable");
        }
        const inputs = { CurrentPage: currentPage, PageCount: lastPage };
        const html = Mustache.to_html(pagerTemplate, inputs);
        $popover.attr("data-content", html);
    }

    private orderLinkClick(e: JQueryEventObject): void {
        const orderBy = $(e.currentTarget).attr("data-order");
        this.model.setOrder(orderBy, false);
        this.model.SearchTree = this.model.CurrentSearchTree;
        this.appEvents.trigger(AppEvents.AppInsightsResultsFilter, {SortFilter: orderBy});
        this.model.emitSearchRequest();
    }

    /**
     * Updates the navbar to show the currently used order in the bar, and all the other exlucing the active one in the dropdown
     */
    private updateOrder() {
        const order = this.model.Order;
        const $orderLinks = this.$(dom.ORDER_LINKS);
        const target = $orderLinks.filter(`[data-order="${order}"]`);
        $orderLinks.show();
        target.hide();
        this.$(dom.SELECTED_ORDER_LABEL).text(target.text());
        this.$(dom.ORDER_TOGGLE + " .dropdown-toggle").toggleClass("highlight", this.model.Order !== "Relevance");
    }

    private pageButtonClick(e: JQueryEventObject): void {
        const $button = $(e.currentTarget);
        if ($button.hasClass("disabled")) { return; }
        const direction = $button.attr("data-page");
        const offset = (direction === "left") ? -1 : 1;
        this.model.setPage(this.model.getPage() + offset, false);
        this.model.SearchTree = this.model.CurrentSearchTree;
        this.appEvents.trigger(AppEvents.AppInsightsResultsFilter, {PageFilter: direction});
        this.model.emitSearchRequest();
    }

    /**
     * Updates UI elements of the pager such as which buttons are disabled, and the current/total page numbers
     */
    private updatePager(): void {

        this.$(dom.CURRENT_PAGE).text(this.model.getPage() || "");
        this.$(dom.TOTAL_PAGES).text(Math.ceil(this.model.getNumberOfResultsForCurrentMaterial() / 10) || "");

        const totalPages = Math.ceil(this.model.TotalResults / 10);

        let rightDisabled = false;
        let leftDisabled = false;
        let middleDisabled = false;

        if (this.model.TotalResults < 1) { // no pages
            leftDisabled = true;
            middleDisabled = true;
            rightDisabled = true;
        }
        if (totalPages === 1) { // only 1 page
            rightDisabled = true;
            middleDisabled = true;
        }
        if (this.model.getPage() === totalPages || this.model.getPage().toString() === this.$(".js-total-pages").text()) { // last page
            rightDisabled = true;
        }
        if (this.model.getPage() === 1) { // first page
            leftDisabled = true;
        }

        this.toggleDisabledStateOfControl(this.$(dom.PAGE_LEFT), leftDisabled);
        this.toggleDisabledStateOfControl(this.$(dom.MIDDLE_PAGER), middleDisabled);
        this.toggleDisabledStateOfControl(this.$(dom.PAGE_RIGHT), rightDisabled);

    }
    /** Enables/disables navigation buttons as appropriate, updates other values in NavBar. This method is called when the Models RefreshNavBar flag is changed,
     * and is also called from elsewhere in the view
     */
    private refreshNavBar(): void {
        this.updateOrder();
        this.updateSearchControls(); // show/hide navbar components
        this.updatePagerPopoverContent();
        this.updatePager();
        this.updateFilterButton();
        this.updateNavbarIcons();

    }

    private updateFilterButton() {
        if (this.model.areWeFiltering()) {
            $("#filter-menu").addClass("filtering");
        } else {
            $("#filter-menu").removeClass("filtering");
        }
    }

    private documentLinkClick(e: JQueryEventObject): boolean {
        if (e.ctrlKey) { return true; }
        const targetDocUrl = $(e.currentTarget).attr("href");
        e.preventDefault();
        Backbone.history.navigate(targetDocUrl, true);
        return false;
    }

    private explanationLinkClick(e: JQueryEventObject): void {
        const title = $(e.currentTarget).attr("title");
        dev.log(title); // Don't remove this!! It allows a superuser to output lucene search info to console when you click the "?"
    }

    private spellingCorrectionClick(e: JQueryEventObject) {
        const query = $(e.currentTarget).text();
        const options: IRequestOptions = {
            includedCategoryFilters: [],
            includedProductFilters: null,
            materialTypes: [],
            order: "Relevance",
            page: 1,
            query,
            replaceHistory: false
        };
        this.appEvents.trigger(AppEvents.SearchRequest, options);
    }

    private loadingChanged() {
        const $mask = this.$(dom.SEARCH_MASK);

        this.$(dom.NO_RESULTS_EXPLANATION_PANEL).hide();
        this.$(dom.NEXT_PAGE_BUTTON).hide();

        this.$(dom.SEARCH_THINKER).toggle(this.model.Loading);

        if (this.model.Loading) {
            $mask.fadeIn(50, "linear");
        } else {
            $mask.fadeOut(50, "linear");
        }

        const mh: MobileHelper = Container.instance.get(MobileHelper);
        if (mh.IsMobileMode) {
            if (this.model.Loading) {
                if (this.model.Results.length > 0) {
                    $("#standard-results-region").scrollTop($("#standard-results-region").scrollTop() + 15); // bring the newly drawn loader into view
                }
            }
        }
        else { // On desktop always want to show top
            $("#standard-results-region").scrollTop(0);
        }

    }

    /**
     * Shows/Hides elements on the navbar depending on if there are results or not.
     */
    private updateSearchControls(): void {

        const resultCount = this.model.TotalUnfilteredResults;
        switch (resultCount) {
            case -1:    // Search data has been emptied
            case undefined:
                this.hideAllControls();
                break;
            case 0:     // There are no unfiltered results
                if (this.model.TotalResults > 0) { // Some filtered searches have results when unfiltered doesn't. eg. advanced case Title[a or not a]
                    this.showAllControls();
                } else {
                    this.hideAllControlsExceptForFilterAndAlertOptions();
                }
                break;
            default:   // Got results
                this.showAllControls();
        }
        this.appEvents.trigger(AppEvents.CancelSuggestions);
    }

    private showAllControls() {
        this.toggleDisabledMenuItem(this.$("#sorter").fadeIn(), false);
        this.toggleDisabledMenuItem(this.$("#pager").fadeIn(), false);
        this.toggleDisabledMenuItem(this.$("#next-page-button").fadeIn(), false);
        this.toggleDisabledMenuItem(this.$("#category").fadeIn(), false);
        this.toggleDisabledMenuItem(this.$("#filter-menu").fadeIn(), false);
        this.toggleDisabledMenuItem(this.$("#download-menu").fadeIn(), false);
        this.toggleDisabledMenuItem(this.$("#alert-menu").fadeIn(), false);
    }

    private hideAllControls() {
        this.toggleDisabledMenuItem(this.$("#sorter").fadeOut(), true);
        this.toggleDisabledMenuItem(this.$("#pager").fadeOut(), true);
        this.toggleDisabledMenuItem(this.$("#next-page-button").fadeOut(), true);
        this.toggleDisabledMenuItem(this.$("#category").fadeOut(), true);
        this.toggleDisabledMenuItem(this.$("#download-menu").fadeOut(), true);
        this.toggleDisabledMenuItem(this.$("#filter-menu").fadeOut(), true);
        this.toggleDisabledMenuItem(this.$("#alert-menu").fadeOut(), true);
        this.$(".message-detail").html("");
        this.hideResultsControlPanel();
    }
    /**
     * This is for when no results are found for the search query, show only the options to expand jurisdictions and setup alerts
     */
    private hideAllControlsExceptForFilterAndAlertOptions() {
        this.toggleDisabledMenuItem(this.$("#filter-menu").fadeIn(), false);
        this.toggleDisabledMenuItem(this.$("#alert-menu").fadeIn(), false);
        this.toggleDisabledMenuItem(this.$("#sorter").fadeOut(), true);
        this.toggleDisabledMenuItem(this.$("#pager").fadeOut(), true);
        this.toggleDisabledMenuItem(this.$("#next-page-button").fadeOut(), true);
        this.toggleDisabledMenuItem(this.$("#download-menu").fadeOut(), true);
    }

    private advancedSearchRunClick(e: JQueryEventObject) {
        e.preventDefault();
        this.model.trigger("searchSubmit");
    }

    private clearClick(e: JQueryEventObject) {
        e.preventDefault();
        this.model.ErrorMessage = "";
        this.model.AdvancedSearch.clearFields();
    }

    private expandSearchLinkClick(): void {
        this.model.JurisdictionOverrides.forEach((j) => {
            j.Ticked = true;
        });
        this.expandProductsLinkClick();
        _.defer(() => {
            this.model.emitSearchRequest();
        });
    }

    private toggleDisabledMenuItem(menuItem: JQuery, disabled: boolean): void {
        this.toggleDisabledStateOfControl(menuItem.find("a").first(), disabled);
    }

    private toggleDisabledStateOfControl(e: JQuery, disabled: boolean): void {
        e.toggleClass("disabled", disabled).attr("aria-disabled", disabled.toString());
    }

    private sorterClick() {
        this.hideResultsControlPanel();
    }

    private closeAdvancedSearchButtonClick(e: JQueryEventObject): void {
        this.model.trigger("closeAdvancedSearch");
    }

    private advancedVisibleChanged(model, visible: boolean): void {
        if (visible) {
            this.showAdvancedSearchForm();
        } else {
            this.hideAdvancedSearchForm();
        }
    }

    private showAdvancedSearchForm(): void {
        $(this.advancedSearchRegion.el).show();
    }

    private hideAdvancedSearchForm(): void {
        this.appEvents.trigger(AppEvents.HideAdvancedSearch);
    }

    private searchClear() {
        this.appEvents.trigger(AppEvents.AppInsightsSearchClear, {Button: "Clicked"});
        this.appEvents.trigger(AppEvents.ClearSearch);
    }
    private updateNavbarIcons(): void {
        this.$(dom.RESULTS_NAVBAR).removeClass("smallicons");

        // Check if the navbar has grown higher than it initially started.
        if (this.$(dom.RESULTS_NAVBAR).height() > 42) {
            this.$(dom.RESULTS_NAVBAR).addClass("smallicons");
        }
    }

    private resultsScroll(e) {
        $(".popover").popover("hide");
    }

    private setAnnouncement(announcementText): void {
        $("#announcement").text(announcementText);
        console.log(announcementText);
    }
}

jQuery.fn.cleanWhitespace = () => {
    this.contents().filter(
        () => (this.nodeType === 3 && !/\S/.test(this.nodeValue)))
        .remove();
    return this;
};

function flexboxSupported() {
    const d = window.document;

    const f = "flex";
    const e = d.createElement("b");
    e.style.display = f;
    return e.style.display === f; // if flex isn't supported, when we set the style.display to "flex" it won't set, and will leave it blank/default value

}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/search/views/search.ts